import * as types from './types'
export default {
  [types.CANCEL_NEWMAKE](state) {
    state.makes = state.makes.filter((item) => item.id !== 0)
  },
  [types.SET_MAKEACTIVATION](state, data) {
    for (const item of state.makes) {
      if (item.id === data.id) {
        item.isInactive = data.isInactive
        item.isChanged = true
        break
      }
    }
  },
  [types.ADD_MAKE](state, make) {
    var cnt = 0
    for (const item of state.makes) {
      if (item.id === 0) {
        cnt++
      }
    }
    if (cnt === 0) {
      state.makes.unshift(make)
    }
  },
  [types.SET_MAKES](state, data) {
    state.makes = []
    if (
      data !== undefined &&
      data !== null
    ) {
      for (const item of data) {
        state.makes.push({
          id: item.id,
          make: item.make,
          isInactive: item.isInactive,
          isChanged: false
        })
      }
    }
  },
  [types.SET_MAKE](state, data) {
    for (const item of state.makes) {
      if (item.id === data.id) {
        item.make = data.make
        item.isChanged = true
        break
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/make/mutations.js